import { useEffect, useState } from "react";
import { fileUrl } from "@/lib/api";
import { getInstagram, saveInstagramItem, deleteInstagramItem } from "@/lib/cloudApi";
import { toast } from "sonner";
import { Trash2, Instagram } from "lucide-react";
import MultiImagePicker from "@/components/admin/MultiImagePicker";

export default function AdminInstagram() {
  const [items, setItems] = useState([]);
  const [link, setLink] = useState("https://www.instagram.com/mangalferafilms/");

  const load = async () => { const data = await getInstagram(); setItems(Array.isArray(data)?data:[]); };
  useEffect(() => { load(); }, []);

  const addBulk = async (urls) => {
    const newOnes = urls.slice(items.length);
    for (const [index, url] of newOnes.entries()) {
      await saveInstagramItem({ url, link, order: items.length + index + 1 });
    }
    if (newOnes.length) toast.success(`${newOnes.length} added`);
    load();
  };

  const del = async (id) => {
    await deleteInstagramItem(id);
    toast.success("Deleted");
    load();
  };

  return (
    <div className="p-10" data-testid="admin-instagram">
      <div className="eyebrow text-[#C99A45]">Manage</div>
      <h1 className="font-serif-display text-5xl mt-3 flex items-center gap-3"><Instagram size={28} /> Instagram Grid</h1>
      <div className="gold-divider my-6"></div>
      <p className="text-[#F7F1E8]/60 text-sm mb-4">Add the latest grid photos manually. Each tile links to your Instagram profile.</p>

      <div className="mb-4">
        <label className="eyebrow text-[10px] text-[#C99A45]/80">Default Instagram link</label>
        <input value={link} onChange={(e) => setLink(e.target.value)} className="w-full bg-transparent border-b border-[#C99A45]/30 focus:border-[#C99A45] outline-none py-2 text-sm max-w-lg block" data-testid="ig-link" />
      </div>

      <div className="border border-[#C99A45]/20 p-6">
        <MultiImagePicker urls={items.map((i) => i.url)} onChange={addBulk} label="Add Instagram photos" testId="ig-multi" />
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3 mt-8">
        {items.map((it) => (
          <div key={it.id} className="relative group" data-testid={`ig-${it.id}`}>
            <img src={fileUrl(it.url)} alt="" className="w-full aspect-square object-cover border border-[#C99A45]/20" />
            <button onClick={() => del(it.id)} className="absolute top-2 right-2 w-7 h-7 bg-[#E52717] text-white flex items-center justify-center opacity-0 group-hover:opacity-100" data-testid={`del-ig-${it.id}`}>
              <Trash2 size={12} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
